<template>
  <div class="homecontent clearfix">
    <div class="home_main">
      <Banner/>
      <div class="main">
        <Announcement/>
        <div class="home_invest">
          <div class="home_invest_data">
            <ul class="home_invest_grid">
              <li></li>
              <li class="home_mark_list" v-for="(v,i) in QualitLoanSchemes" :key="i">
                <InvestMark :data="v"/>
              </li>
            </ul>
            <div class="home_invest_icon">
              <img v-if="lang=='cn'" src="../assets/index_rec.png" alt>
              <img v-if="lang=='hk'" src="../assets/good.png" alt>
            </div>
          </div>
        </div>
        <Row class="home_advertisement_display">
          <Col span="6" class="invest" v-for="(v,i) in [
            {title:$t('other.w1'),dec:$t('other.w2'),img:'invest'},
            {title:$t('other.w3'),dec:$t('other.w4'),img:'loan'},
            {title:$t('other.w5'),dec:$t('other.w6'),img:'safectr'},
            {title:$t('other.w7'),dec:$t('other.w8'),img:'safeprt'},
          ]" :key="i">
            <div :class="`${v.img}-img`"></div>
            <p>{{v.title}}</p>
            <p>{{v.dec}}</p>
          </Col>
        </Row>
      </div>
    </div>
    <div class="home_LoadStatisticData" v-show="statistical">
      <div class="home_introduction" v-show="false">
        <div class="home_introduction_main">
          <p>{{$t('other.w9')}}</p>
          <p>{{$t('other.w10')}}</p>
        </div>
      </div>
      <div class="home_statistical_list" v-show="false">
        <Row class="home_statistical">
          <Col span="8" class="home_statistical_vip">
            <p>{{statistic.TotalUserCount}}</p>
            <p>{{$t('other.w11')}}</p>
          </Col>
          <Col span="8" class="home_statistical_total">
            <p>{{(statistic.TotalLoanAmount/100000000).toFixed(4)}}</p>
            <p>{{$t('other.w12')}}</p>
          </Col>
          <Col span="8" class="home_statistical_time">
            <p>{{statistic.LoanAvgBeginAt}}</p>
            <p>{{$t('other.w13')}}</p>
          </Col>
        </Row>
      </div>
    </div>
    <div class="home_newborrowlist_box">
      <div class="home_newborrowlist_main">
        <div class="home_newborrowlist_top">
          <div class="home_newborrowlist_top_l fl">
            <p>{{$t('title.w4')}}</p>
            <p>LATEST BORROWING LIST</p>
          </div>
          <div class="home_newborrowlist_top_r fr" @click="()=>this.$router.push({name:'invest'})">{{$t('nav.w3')}}</div>
        </div>
        <Newborrowlist :data="NewLoanSchemes"/>
      </div>
    </div>
    <div class="home_company_profile">
      <div class="home_company_main">
        <div class="home_company_disc">
          <p>{{$t('title.w5')}}</p>
          <p>{{$t('other.w14')}}</p>
        </div>
        <ul class="home_invest_loan_tab">
          <li
            v-bind:class="{home_invest_loan_tab_active :ProcesState}"
            @click="home_invest_loan_tab"
          >{{$t('nav.w4')}}</li>
          <li
            v-bind:class="{home_invest_loan_tab_active :!ProcesState}"
            @click="home_invest_loan_tab"
          >{{$t('nav.w5')}}</li>
        </ul>
        <div class="home_invest_loan_content">
          <ul class="home_invest_content" v-show="ProcesState">
            <li v-for="(v,i) in [
              {title:$t('other.w15'),dec:$t('other.w16')},
              {title:$t('other.w17'),dec:$t('other.w18')},
              {title:$t('other.w19'),dec:$t('other.w20')},
              {title:$t('other.w21'),dec:$t('other.w22')}
            ]" :key="i">
              <p></p>
              <p>{{v.title}}</p>
              <p>{{v.dec}}</p>
            </li>
          </ul>
          <ul class="home_loan_content" v-show="!ProcesState">
            <li v-for="(v,i) in [
             {title:$t('other.w15'),dec:$t('other.w16')},
              {title:$t('other.w23'),dec:$t('other.w24')},
              {title:$t('other.w25'),dec:$t('other.w26')},
              {title:$t('other.w27'),dec:$t('other.w28')}
            ]" :key="i">
              <p></p>
              <p>{{v.title}}</p>
              <p>{{v.dec}}</p>
            </li>
          </ul>
        </div>
        <div class="home_automatic_bid">
          <p>{{$t('other.w29')}}</p>
          <p>{{$t('other.w30')}}</p>
          <div class="home_automatic_bid_btn">
            <span @click="()=>this.$router.push({name:'createbid'})">{{$t('nav.w6')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="home_domainPrice_link">
      <div class="home_domainPrice_link_main">
        <p>{{$t('other.w31')}}</p>
        <p>{{$t('other.w32')}}</p>
        <a href="http://www.62.com/" target="_Blank">{{$t('nav.w7')}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import InvestMark from '../components/invest_mark'
import {getOnce} from '@/libs/axios'

import Banner from '../components/banner'
import Announcement from '../components/announcement'
import Newborrowlist from '../components/newborrowlist'

export default {
  components: {
    InvestMark,
    Banner,
    Announcement,
    Newborrowlist
  },
  data() {
    return {
      ProcesState: true,
      statistical: true,
      
      statistic:{},// 平台运营数据
      QualitLoanSchemes:[],//优选好标
      NewLoanSchemes:undefined,//最新借款列表
    };
  },
  methods: {
    home_invest_loan_tab() {
      this.ProcesState = !this.ProcesState;
    },
    // 获取平台运营数据
    getStatistic(){
      getOnce('/Member/RZJPageIndex/LoadStatisticData')
      .then(res=>{
        this.statistic=res.TotalData
      })
    },
    // 获取 优选好标+最新借款列表
    getNewLoadData(){
      this.$axios.get('/Member/RZJPageIndex/NewLoadData')
      .then(res=>{
        this.QualitLoanSchemes=res.QualitLoanSchemes
        this.NewLoanSchemes=res.NewLoanSchemes
      })
    }
  },
  mounted() {
    this.getStatistic()
    this.getNewLoadData()
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    }
  }
};
</script>

<style lang="less" scoped>
.homecontent {
  width: 100%;
  position: relative;
  background: #f1f2f5;
  .main {
    width: 1200px;
    margin: 0 auto;
    position: relative;
    .home_invest {
      width: 100%;
      height: 200px;
      background: #f1f2f5;
      margin-top: 70px;
      .home_invest_data {
        height: 200px;
        background: #fff;
        position: relative;
        .home_invest_grid {
          width: 1200px;
          height: 200px;
          background: #fff;
          li {
            float: left;
            height: 200px;
            width: 320px;
          }
          li:nth-child(2) {
            position: relative;
            &::after {
              content: "";
              width: 7px;
              height: 166px;
              background: url("../assets/index_rec_line.png") no-repeat;
              background-size: 7px 166px;
              position: absolute;
              right: 40px;
              top: 20px;
            }
          }
          li:nth-child(3) {
            position: relative;
            &::after {
              content: "";
              width: 7px;
              height: 166px;
              background: url("../assets/index_rec_line.png") no-repeat;
              background-size: 7px 166px;
              position: absolute;
              right: 40px;
              top: 20px;
            }
          }
          .home_mark_list {
            padding: 20px 0;
          }
        }
        li:first-child {
          width: 240px;
        }
        .home_invest_icon {
          position: absolute;
          top: -30px;
          img {
            width: 240px;
            height: 260px;
            display: inline-block;
          }
        }
      }
    }
    .home_advertisement_display {
      height: 260px;
      width: 1200px;
      margin-top: 15px;
      .invest {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        margin: 44px 0;
        >div{
          width: 100px;
          height: 100px;
          background: url("../assets/public_advantage.png") no-repeat;
          background-size: cover;
          &.invest-img{
            background-position: 0 0;
          }
          &.loan-img{
            background-position:-100px 0;
          }
          &.safectr-img{
            background-position: -200px 0;
          }
          &.safeprt-img{
            background-position:-300px 0;
          }
        }
        p:nth-child(2) {
          height: 25px;
          font-size: 18px;
          color: rgba(35, 35, 37, 1);
          line-height: 25px;
          margin: 20px 0 10px 0;
        }
        p:last-child {
          height: 17px;
          font-size: 12px;
          color: rgba(123, 123, 124, 1);
          line-height: 17px;
        }
      }
    }
  }
  .home_LoadStatisticData {
    .home_introduction {
      width: 100%;
      height: 270px;
      background: url("../assets/index_textbg.svg") no-repeat;
      background-size: 100%;
      .home_introduction_main {
        height: 270px;
        margin: 0 auto;
        width: 1200px;
        text-align: center;
        padding: 110px 315px 30px 315px;
        p:first-child {
          width: 569px;
          height: 42px;
          font-size: 30px;
          color: rgba(35, 35, 37, 1);
          letter-spacing: 2px;
          line-height: 42px;
          margin-bottom: 10px;
        }
        p:last-child {
          width: 569px;
          height: 40px;
          font-size: 14px;
          color: rgba(123, 123, 124, 1);
          line-height: 20px;
        }
      }
    }
    .home_statistical_list {
      width: 100%;
      height: 181px;
      background: #fff;
      .home_statistical {
        width: 1200px;
        height: 181px;
        margin: 0 auto;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        .home_statistical_vip {
          position: relative;
          p:first-child {
            height: 58px;
            font-size: 48px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(0, 25, 85, 1);
            line-height: 58px;
          }
          p:last-child {
            height: 20px;
            font-size: 14px;
            color: rgba(123, 123, 124, 1);
            line-height: 20px;
          }
          &::after {
            width: 3px;
            height: 123px;
            content: "";
            background: url("../assets/index_rec_line.png") no-repeat;
            background-size: cover;
            position: absolute;
            right: 0;
            top: -25px;
          }
        }
        .home_statistical_total {
          p:first-child {
            height: 58px;
            font-size: 48px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(0, 25, 85, 1);
            line-height: 58px;
          }
          p:last-child {
            height: 20px;
            font-size: 14px;
            color: rgba(123, 123, 124, 1);
            line-height: 20px;
          }
          &::after {
            width: 3px;
            height: 123px;
            content: "";
            background: url("../assets/index_rec_line.png") no-repeat;
            background-size: cover;
            position: absolute;
            right: 0;
            top: -25px;
          }
        }
        .home_statistical_time {
          p:first-child {
            height: 58px;
            font-size: 48px;
            font-family: DIN-Medium;
            font-weight: 500;
            color: rgba(0, 25, 85, 1);
            line-height: 58px;
          }
          p:last-child {
            height: 20px;
            font-size: 14px;
            color: rgba(123, 123, 124, 1);
            line-height: 20px;
          }
        }
      }
    }
  }
  .home_newborrowlist_box {
    width: 100%;
    margin-bottom: 240px;
    .home_newborrowlist_main {
      width: 1200px;
      margin: 0 auto;
      .home_newborrowlist_top {
        margin-top: 50px;
        height: 40px;
        width: 1200px;
        margin-bottom: 25px;
        .home_newborrowlist_top_l {
          p:first-child {
            height: 33px;
            font-size: 24px;
            font-weight: bold;
            color: rgba(35, 35, 37, 1);
            line-height: 33px;
          }
          p:last-child {
            height: 17px;
            font-size: 12px;
            color: rgba(123, 123, 124, 1);
            line-height: 17px;
          }
        }
        .home_newborrowlist_top_r {
          width: 130px;
          height: 40px;
          background: rgba(241, 242, 245, 1);
          border-radius: 2px;
          border: 1px solid #7b7b7c;
          font-size: 16px;
          color: #7b7b7c;
          line-height: 40px;
          text-align: center;
          position: relative;
          cursor: pointer;
          &::after {
            width: 16px;
            height: 10px;
            content: "";
            position: absolute;
            right: 12px;
            top: 14px;
            background: url("../assets/public_arrow.png") no-repeat;
            background-size: cover;
          }
        }
      }
      .home_newborrowlist_list {
        width: 1200px;
      }
    }
  }
  .home_company_profile {
    width: 100%;
    height: 738px;
    background: url("../assets/index_tabbg.jpg") left no-repeat;
    background-size: 100%;
    position: relative;
    .home_company_main {
      width: 1200px;
      position: relative;
      margin: 0 auto;
      height: 540px;
      padding-top: 200px;
      .home_company_disc {
        text-align: center;
        width: 700px;
        margin: 0 auto;
        p:first-child {
          height: 42px;
          width: 700px;
          font-size: 30px;
          color: rgba(35, 35, 37, 1);
          letter-spacing: 2px;
          line-height: 42px;
          margin-bottom: 13px;
        }
        p:last-child {
          width: 700px;
          height: 40px;
          font-size: 14px;
          color: rgba(123, 123, 124, 1);
          line-height: 20px;
        }
      }
      .home_invest_loan_tab {
        height: 78px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 32px;
        border-bottom: 1px solid rgba(215, 215, 217, 1);
        li {
          width: 72px;
          height: 78px;
          cursor: pointer;
          font-size: 18px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          line-height: 78px;
          margin-left: 64px;
          color: rgba(35, 35, 37, 1);
        }
        .home_invest_loan_tab_active {
          position: relative;
          color: rgba(106, 152, 255, 1);
          &::after {
            width: 72px;
            height: 4px;
            background: rgba(106, 152, 255, 1);
            position: absolute;
            left: 0;
            bottom: 0;
            content: "";
          }
        }
        li:first-child {
          margin-right: 64px;
          margin-left: 0;
        }
      }
      .home_invest_loan_content {
        width: 100%;
        height: 340px;
        .home_invest_content {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          li {
            width: 300px;
            height: 340px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            flex-direction: column;
            p:first-child {
              width: 50px;
              height: 50px;
              background: url("../assets/index_process50x50.png");
              background-size: cover;
              margin-bottom: 40px;
              margin-top: -70px;
            }
            p:nth-child(2) {
              height: 22px;
              font-size: 16px;
              color: rgba(35, 35, 37, 1);
              line-height: 22px;
            }
            p:last-child {
              height: 20px;
              font-size: 14px;
              color: rgba(123, 123, 124, 1);
              line-height: 20px;
            }
          }
          li:nth-child(2) {
            p:first-child {
              background-position: -50px, 0;
            }
          }
          li:nth-child(3) {
            p:first-child {
              background-position: -100px, 0;
            }
          }
          li:nth-child(4) {
            p:first-child {
              background-position: -150px, 0;
            }
          }
        }
        .home_loan_content {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          li {
            width: 300px;
            height: 340px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            flex-direction: column;
            p:first-child {
              width: 50px;
              height: 50px;
              background: url("../assets/index_process50x50.png");
              background-size: cover;
              margin-bottom: 40px;
              margin-top: -70px;
            }
            p:nth-child(2) {
              height: 22px;
              font-size: 16px;
              color: rgba(35, 35, 37, 1);
              line-height: 22px;
            }
            p:last-child {
              height: 20px;
              font-size: 14px;
              color: rgba(123, 123, 124, 1);
              line-height: 20px;
            }
          }
          li:nth-child(2) {
            p:first-child {
              background-position: -200px, 0;
            }
          }
          li:nth-child(3) {
            p:first-child {
              background-position: -250px, 0;
            }
          }
          li:nth-child(4) {
            p:first-child {
              background-position: -300px, 0;
            }
          }
        }
      }
      .home_automatic_bid {
        width: 1200px;
        height: 246px;
        background: url("../assets/index_ad.png") no-repeat;
        background-size: 100%;
        position: absolute;
        left: 0;
        top: -146px;
        padding: 70px 0 40px 80px;
        p {
          width: 361px;
          height: 42px;
          height: 42px;
          font-size: 30px;
          font-family: PingFangSC-Light;
          font-weight: 300; 
          color: rgba(35, 35, 37, 1);
          line-height: 42px;
        }
        .home_automatic_bid_btn {
          width: 160px;
          height: 40px;
          margin-top: 20px;
          line-height: 40px;
          cursor: pointer;
          border-radius: 2px;
          opacity: 0.6;
          border: 1px solid rgba(123, 123, 124, 1);
          text-align: center;
          font-size: 16px;
          position: relative;
          &::after {
            width: 16px;
            height: 10px;
            content: "";
            position: absolute;
            top: 15px;
            right: 25px;
            background: url("../assets/public_arrow.png") left no-repeat;
            background-size: cover;
          }
        }
      }
    }
  }
  .home_domainPrice_link {
    width: 100%;
    height: 180px;
    background: url("../assets/index_d2.png") no-repeat;
    background-size: cover;
    .home_domainPrice_link_main {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 1200px;
      height: 180px;
      margin: 0 auto;
      p:first-child {
        height: 42px;
        font-size: 30px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        margin-bottom: 3px;
        word-spacing: 4px;
      }
      p:nth-child(2) {
        height: 20px;
        font-size: 14px;
        color: #afbad1;
        line-height: 20px;
        margin-bottom: 10px;
      }
      a {
        opacity: 0.6;
        display: block;
        width: 130px;
        height: 40px;
        border-radius: 2px;
        border: 1px solid #fefeff;
        text-align: center;
        padding: 9px 0;
        color: #fefeff;
        position: relative;
        &::after {
          width: 16px;
          height: 10px;
          content: "";
          background: url("../assets/public_arrow.png") no-repeat;
          background-position: -16px 0;
          background-size: cover;
          position: absolute;
          right: 19px;
          top: 13px;
        }
      }
    }
  }
}
</style>



